(() => {
  if (window.rmBfReleaseLoaded) return;
  window.rmBfReleaseLoaded = true;
  const badges = [...document.querySelectorAll('[data-bf-launch-at]')];
  const updateBadges = () => badges.forEach(badge => {
    const delay = Date.parse(badge.dataset.bfLaunchAt) - Date.now();
    badge.hidden = delay > 0;
    if (delay > 0) setTimeout(updateBadges, Math.min(delay + 30, 2147483647));
  });
  updateBadges();
  if (!location.pathname.startsWith('/pages/') || new URLSearchParams(location.search).get('view') !== 'b1g2-october' || !document.querySelector('[data-bf-landing]')) return;
  const historyUrl = location.pathname;
  const preservePage = () => {
    const facets = document.querySelector('rm-facets');
    if (facets) {
      facets.dataset.resultsUrl = '/collections/black-friday-sale';
      facets.dataset.historyUrl = historyUrl;
      facets.dataset.resultView = 'black-friday-2026';
      if (!facets.querySelector('input[name="view"]')) {
        const input = document.createElement('input');input.type = 'hidden';input.name = 'view';input.value = 'b1g2-october';facets.querySelector('form')?.append(input);
      }
    }
    document.querySelectorAll('#ProductGridContainer .pagination a').forEach(link => {
      const url = new URL(link.href);url.pathname = historyUrl;url.searchParams.set('view', 'b1g2-october');link.href = url.pathname + url.search;
    });
  };
  document.addEventListener('collection:reloaded', preservePage);
  const params = new URLSearchParams(location.search);params.set('view','black-friday-2026');
  fetch('/collections/black-friday-sale?' + params.toString()).then(response => {if(!response.ok)throw new Error('Collection unavailable');return response.text();}).then(text => {
    const doc = new DOMParser().parseFromString(text,'text/html');
    const grid = document.getElementById('ProductGridContainer');const newGrid = doc.getElementById('ProductGridContainer');
    const facets = document.querySelector('rm-facets');const newFacets = doc.querySelector('rm-facets');
    if (grid && newGrid && facets && newFacets) {grid.innerHTML = newGrid.innerHTML;facets.replaceWith(newFacets);preservePage();document.dispatchEvent(new CustomEvent('collection:reloaded'));}
  }).catch(error => console.error('[BF collection]',error));
})();
